import React from "react";
import useProducts from "../../hooks/useProducts";
import Navigation from "../Shared/Navigation/Navigation";
import Footer from "../Shared/Footer/Footer";
import ExploreProducts from "./ExploreProducts";

const SkeletonCard = () => (
  <div className="animate-pulse bg-white rounded-2xl overflow-hidden shadow-sm">
    <div className="h-52 bg-gray-200" />
    <div className="p-5 space-y-3">
      <div className="h-4 bg-gray-200 rounded w-3/4" />
      <div className="h-3 bg-gray-200 rounded w-full" />
      <div className="h-3 bg-gray-200 rounded w-5/6" />
      <div className="h-9 bg-gray-200 rounded-full mt-4" />
    </div>
  </div>
);

const Explore = () => {
  const [products, loading] = useProducts();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navigation />

      {/* Page Header */}
      <div className="bg-slate-900 text-white py-16 px-6 text-center">
        <p className="text-amber-400 text-sm font-semibold uppercase tracking-widest mb-3">
          Find your companion
        </p>
        <h1 className="text-4xl sm:text-5xl font-bold mb-4">Explore Our Pets</h1>
        <p className="text-slate-400 max-w-xl mx-auto text-base">
          Browse our full collection of healthy, well-socialized pets looking for
          their forever homes.
        </p>
      </div>

      {/* Grid */}
      <main className="max-w-7xl mx-auto px-6 py-14 w-full flex-1">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {Array.from({ length: 6 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-slate-400 text-lg">
            No pets available right now. Check back soon! 🐾
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {products.map((product) => (
              <ExploreProducts key={product._id} product={product} />
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Explore;
